import { render, staticRenderFns } from "./CalendarYears.vue?vue&type=template&id=94e74b2a"
import script from "./CalendarYears.vue?vue&type=script&lang=js"
export * from "./CalendarYears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports